/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CountApi } from '../api/count.api';
import { switchMap, map } from 'rxjs/operators';
import { Count,CountData } from '../../../interfaces/masters/count';

@Injectable()
export class CountService extends CountData {

  constructor(private api:CountApi) {
    super();
  }


  list(url: string): Observable<Count[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Count>{
      return this.api.getById(url);
  }

  create(url: string, data:Count): Observable<Count> {
    return this.api.add(url,data);
  }

  update(url: string, data:Count): Observable<Count> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
